import { render, staticRenderFns } from "./DeliveryDetail.vue?vue&type=template&id=14abf973&scoped=true&"
import script from "./DeliveryDetail.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDetail.vue?vue&type=style&index=0&id=14abf973&scoped=true&lang=less&"
import style1 from "./DeliveryDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14abf973",
  null
  
)

export default component.exports